import Class from './c-content-chart-model-data';
import './c-content-chart-model-data@.vue';

export default Class;